/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-dashboard': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15 13.125h1.25v3.125H15v-3.125zM12.5 10h1.25v6.25H12.5V10zm-5.625 6.25a3.129 3.129 0 01-3.125-3.125H5a1.875 1.875 0 101.875-1.875V10a3.125 3.125 0 010 6.25zm10.625-15h-15c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h15a1.252 1.252 0 001.25-1.25v-15c0-.69-.56-1.25-1.25-1.25zm0 5.625H8.75V2.5h8.75v4.375zM7.5 2.5v4.375h-5V2.5h5zm-5 15V8.125h15l.001 9.375H2.5z"/>'
  }
})
